import styled from 'styled-components';
import { ThemeColours } from '../../../styles/ThemeColours';
import { PRESSABLE } from '../../../styles/constants';

export const SpecialtyContainer = styled.div`
  ${PRESSABLE}
  display: flex;
  flex-wrap: wrap;
  text-decoration: none;

  &:visited,
  &:active,
  &:link {
    color: inherit;
  }

  &:hover {
    color: ${ThemeColours.primary500};
  }
`;
